module.exports = __webpack_public_path__ + "static/media/launay2Portrait.39636768.JPG";